import { IAppState } from '../../redux';

export const selectIsFromXml = (state: IAppState): boolean => {
  return state.offer.isFromXml;
};
